module.exports = __webpack_public_path__ + "a1c038494d569da4cef430a981d6e4f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/history/4.jpg
// module id = 253
// module chunks = 0